import Link from "next/link";
import styles from "./BlogSec1.module.css";
import Breadcrumbs from "@/Component/Common/Breadcrumbs";
import {
  BLOG_MONTH_SECTION_ID,
  getRegionPath,
  isMonthlyUpdatesCategory,
} from "@/utils/blogHelpers";
import { scrollToSectionById } from "@/utils/scrollToSection";

export default function BlogSec1({ categories = [], country = "UAE" }) {
  const scrollToMonthSection = (event) => {
    event.preventDefault();
    scrollToSectionById(BLOG_MONTH_SECTION_ID);
  };

  return (
    <>
      <Breadcrumbs />
      <section className={`${styles.blogsecContainer} standard-padding`}>
        {categories.length ? (
          <div className={styles.blogsecGrid}>
            {categories.map((item) => {
              const isMonthly = isMonthlyUpdatesCategory(item);
              const cardContent = (
                <>
                  <div className={styles.blogsecIconWrap}>
                    <img
                      src={item.iconSrc}
                      alt={item.title}
                      className={styles.blogsecIconImg}
                    />
                  </div>
                  <span className={styles.blogsecTitle}>{item.title}</span>
                </>
              );

              if (isMonthly) {
                return (
                  <a
                    key={item.id || item.slug}
                    href={`#${BLOG_MONTH_SECTION_ID}`}
                    className={styles.blogsecCard}
                    onClick={scrollToMonthSection}
                  >
                    {cardContent}
                  </a>
                );
              }

              return (
                <Link
                  key={item.id || item.slug}
                  href={getRegionPath(country, `/blog/${item.slug}`)}
                  className={styles.blogsecCard}
                >
                  {cardContent}
                </Link>
              );
            })}
          </div>
        ) : (
          <p className="nodata">No categories available at the moment.</p>
        )}
      </section>
    </>
  );
}
